import { render, staticRenderFns } from "./m-block-demo-account-confirm.vue?vue&type=template&id=8b587560&scoped=true&lang=pug&"
import script from "./m-block-demo-account-confirm.vue?vue&type=script&lang=js&"
export * from "./m-block-demo-account-confirm.vue?vue&type=script&lang=js&"
import style0 from "./m-block-demo-account-confirm.vue?vue&type=style&index=0&id=8b587560&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b587560",
  null
  
)

export default component.exports